import React, { Component } from "react";
import checkLogin from "../../Utils/checkLogin";
import LoaderSpinner from "../../../componentes/LoaderSpinner";
import request from "superagent";
import { defaultPaperPadding, tableRowBackground, url_endpoint } from "../../../config";
import authHeader from "../../Utils/AuthHeader";
import { Button, CardHeader, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import palette from "../../../theme/palette";
import DateRangePickers from "../Dashboard/components/DateRangePickers";
import { Link } from "react-router-dom";
import moment from "moment";
import ImageIconBox from "../components/ImageIconBox";
import ListCheckIcon from '../../../images/icons/list_check_icon.svg'

class AdCampaings extends Component {
    constructor(props) {
        super(props)

        this.props.setTitulo('Campanhas')

        const today = new Date()

        this.state = {
            loading: true,
            client: null,
            dialogOpen: false,
            dialogTitle: '',
            dialogMessage: '',
            campaigns: [],
            searchingActive: true,
            startRange: new Date(today.getFullYear(), today.getMonth(), 1, -3),
            endRange: new Date(today.getFullYear(), today.getMonth() + 1, 0, -3),
        }
    }

    async getBaseCampaings() {
        try {
            const baseCampaignsRequest = await request.get(url_endpoint + "adCampaign/baseCampaigns/" + (this.state.searchingActive ? 'active/' : 'inactive/') + this.state.startRange.toISOString() + '/' + this.state.endRange.toISOString()).set(authHeader());

            this.setState({ campaigns: baseCampaignsRequest.body })
        } catch (e) {
            this.setState({ dialogOpen: true, dialogTitle: 'Erro ao buscar campanhas', dialogMessage: e.response.text })
        }
    }

    async componentDidMount() {
        const clientData = await checkLogin(false)

        await this.getBaseCampaings()

        this.setState({ loading: false, client: clientData })
    }

    changerangedata = async (startDate, endDate) => {
        this.setState({ loading: true })

        const startRange = moment(startDate).startOf('day').toDate()
        const endSelected = moment(endDate).startOf('day').toDate()

        endSelected.setHours(23, 59, 59)

        this.setState({ startRange: startRange, endRange: endSelected })

        await this.getBaseCampaings()

        this.setState({ loading: false })
    }

    buildRows() {
        const rows = []

        for (let i = 0; i < this.state.campaigns.length; i++) {
            rows.push(this.buildCampaignRow(this.state.campaigns[i], i))
        }

        return rows
    }

    buildCampaignRow(campaign, index) {
        return <TableRow style={{ backgroundColor: index % 2 == 0 ? tableRowBackground : 'transparent' }} key={campaign.id}>
            <TableCell align="left" style={{ color: 'grey', fontSize: '17px', }}>{campaign.title}</TableCell>
            <TableCell align="left" style={{ color: 'grey', fontSize: '17px', }}>{moment(campaign.createdAt).format('DD/MM/YYYY')}</TableCell>
            <TableCell align="center" style={{ color: 'grey' }}>
                <Link to={`/painel/campanhas/editar/${campaign.id}`}>
                    <Button variant="contained" color="primary">Editar</Button>
                </Link>
            </TableCell>
        </TableRow>
    }

    render() {
        return <div>
            <Dialog
                open={this.state.dialogOpen}
                onClose={() => {
                    this.setState({ dialogOpen: false })
                }}
            >
                <DialogTitle>
                    <span style={{ 'color': palette.primary.main, fontSize: '20px' }}>{this.state.dialogTitle}</span>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <span style={{ fontSize: '14px' }}>{this.state.dialogMessage}</span>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <span onClick={() => {
                        this.setState({ dialogOpen: false })
                    }} style={{ cursor: 'pointer', 'color': palette.primary.main, fontSize: '16px' }}>
                        {"OK"}
                    </span>
                </DialogActions>
            </Dialog>
            {this.state.loading && <LoaderSpinner></LoaderSpinner>}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', marginBottom: '20px' }}>
                <h2>Campanhas publicitárias</h2>
                <Link to={"/painel/campanhas/nova"}>
                    <Button variant="contained" color="primary">Nova Campanha</Button>
                </Link>
            </div>
            <Paper style={{ padding: defaultPaperPadding }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <ImageIconBox size='50px' padding='10px' src={ListCheckIcon}></ImageIconBox>
                    <DateRangePickers changerangedata={this.changerangedata}></DateRangePickers>
                </div>
                {this.state.campaigns.length == 0 && <h3 style={{ color: 'grey', margin: '10px 0' }}>Nenhuma campanha encontrada</h3>}
                <FormControlLabel
                    label="Campanhas ativas"
                    control={
                        <Switch color="primary" checked={this.state.searchingActive} onChange={async (e) => {
                            this.state.searchingActive = !this.state.searchingActive
                            this.setState({ loading: true })
                            await this.getBaseCampaings()
                            this.setState({ loading: false })
                        }}></Switch>
                    }
                ></FormControlLabel>
                {this.state.campaigns.length > 0 &&
                    <TableContainer>
                        <Table>
                            <TableHead style={{ backgroundColor: 'transparent' }}>
                                <TableRow>
                                    <TableCell style={{ color: 'grey' }} align="left">Título</TableCell>
                                    <TableCell style={{ color: 'grey' }} align="left">Data</TableCell>
                                    <TableCell style={{ color: 'grey' }} align="center"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.buildRows()}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </Paper>
        </div>
    }
}

export default AdCampaings